import type {
  CompleteSupplierOnboardingDto,
  UpdateOperationalLocationDto,
} from '@paladin-monorepo/common';
import API from '@/lib/api';

export const onboardingApi = {
  updateOperationalLocation(dto: UpdateOperationalLocationDto) {
    return API.patch<{ ok: boolean }>('/me/account/operational-location', dto).then(
      (r) => r.data,
    );
  },

  completeSupplierOnboarding(dto: CompleteSupplierOnboardingDto) {
    return API.post<{ completed: boolean }>('/me/onboarding', dto).then((r) => r.data);
  },
};
